<template>
  <div class="minor-banner">
    <div class="minor-margin">
      <template v-for="(banner,index) in bannerList">
        <div class="item-box" :key="index">
          <div class="img" :class="{'url-flag':banner.url}">
            <img :src="banner.src" @click="openUrl(banner.url)">
          </div>
          <div class="name">{{ banner.name }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getBannerList } from '@/api/bannerApi'

export default {
  name: 'h-minor-banner',
  data() {
    return {
      bannerList: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getBannerList()
    },
    getBannerList() {
      const $this = this
      let params = {};
      params.type = '2';//小图
      params.valid = '1'
      getBannerList(params).then(res => {
        $this.bannerList = res.data
      })
    },
    openUrl(url){
      if(url){
        if (url.startsWith("http")) {
          window.open(url);
        } else {
          this.$router.push({ path: url});
        }
      }
    }
  }
}
</script>

<style scoped>

.minor-banner {
  position: relative;
  z-index: 5;
  margin-top: -40px;
  margin-bottom: 30px;
  height: 164px;
}

.minor-banner .minor-margin {
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
}

.minor-margin .item-box {
  width: 100px;
  margin: 20px;
  overflow: hidden;

}

.minor-margin .item-box .name {
  margin-top: 10px;
  font-size: 14px;

}

.minor-margin img {
  border-radius: 10px;
  box-shadow: 0 4px 4px #c4c4c4;
  width: 100px;
  height: 100px;
  object-fit: cover;
  display: block;
  transition: all .5s;
}
.minor-margin .url-flag {
 cursor: pointer;
}

.minor-margin div:hover img {
  transform: scale(1.1);
}
</style>
